module.exports = __webpack_public_path__ + "static/media/leak.9ca8f30c.svg";